module.exports = __webpack_public_path__ + "static/media/AQ.12c51113.svg";